/**
 * Model to confirm archival deletion.
 *
 * @author mohit.khurana@vernuso.com (Mohit Khurana)
 */
export class ArchivalConfirm {
    // Model properties have been kept in lowercase as per the FormParams
    // accepted by rest server.
    deleteReason: string;
    deleteClientOnly: boolean;
    entityId: number;
}



// WEBPACK FOOTER //
// ./src/app/admin/archival/archivalconfirm/archival-confirm.model.ts